import { Component } from '@angular/core';
import { Button, ButtonModule } from 'primeng/button';
import { Drawer, DrawerModule } from 'primeng/drawer';

@Component({
    selector: 'app-ngdrawer',
    imports: [Drawer, Button, ButtonModule, DrawerModule],
    //templateUrl: './ngdrawer.component.html',
    template: `
        <div class="card flex justify-center">
            <p-drawer
                header="Drawer"
                [(visible)]="visible"
                [style]="{ width: '96vw' }"
            >
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
            </p-drawer>
            <p-button (click)="visible = true" icon="pi pi-window-maximize" />
        </div>
    `,
    standalone: true,
    styleUrl: './ngdrawer.component.scss',
})
export class NgdrawerComponent {
    visible = false;
}
